'use strict';

require('./core/ErrorHandler.js').default;
var ReactDom = require('react-dom');
var Routes = require('./core/Routes');
var IgnoredMainStyles = require('./less/main.less');
var ApplicationsApi = require('./apis/ApplicationsAPI.js');
var YourDetailsApi = require('./apis/YourDetailsAPI.js');
var ClientsApi = require('./apis/ClientsAPI.js');
var ProductsApi = require('./apis/ProductsAPI.js');
var HttpClient = require('./apis/HttpClient.js');

// setup bluebird to catch unhandled errors in Promises
Promise.onPossiblyUnhandledRejection((e/*, promise*/) => {
    throw e
});
// To suppress this: "Warning: a promise was rejected with a non-error"
Promise.config({
    warnings: false
});
HttpClient.init();
ProductsApi.getProductList();
YourDetailsApi.getTitleList();
YourDetailsApi.getCountryList();
YourDetailsApi.getTfnExemptionList();
YourDetailsApi.getSourceOfFundList();
YourDetailsApi.getSourceOfWealthList();
ApplicationsApi.resolveApplication();
ClientsApi.resolveClient();
ReactDom.render(Routes, document.getElementById('app'));


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./Main.jsx